// Exclude vue js from common js bundle - import vue as a <script> instead
// import Vue from "vue";

// Import all of the modules that are expected to be used in the related view
import BeforeAfter from "./BeforeAfter.vue";
Vue.component("before-after", BeforeAfter);

// Wrap creating the vue app in a function to check if the ID exists on the page. This prevents Vue from throwing errors
const id = "vue-app-before-after";
if (document.getElementById(id)) {
    new Vue({  
        el: "#" + id
    });
}
